import {useMemo} from 'react';
import {usePaginationFragment} from 'react-relay';
import {DashboardTicketsPaginationFragment, DASHBOARD_TICKET_PAGE_SIZE} from './useDashboardTicketsQuery';
import {dashboardTicketFromNode, type DashboardTicketNode} from '../utils/dashboardTicketFromNode';
import type {useDashboardTicketsQuery_tickets$key} from './__generated__/useDashboardTicketsQuery_tickets.graphql';
import type {DashboardTicket} from '../types/dashboardTicket';

export interface UseDashboardTicketsResult {
	items: DashboardTicket[];
	hasNextPage: boolean;
	isLoadingNext: boolean;
	loadNext: (count?: number) => void;
}

export function useDashboardTickets(queryRef: useDashboardTicketsQuery_tickets$key): UseDashboardTicketsResult {
	const {data, loadNext, hasNext, isLoadingNext} = usePaginationFragment(DashboardTicketsPaginationFragment, queryRef);

	const items = useMemo(
		() =>
			(data.tickets.edges ?? [])
				.map(edge => edge?.node)
				.filter((node): node is DashboardTicketNode => node != null)
				.map(dashboardTicketFromNode),
		[data.tickets.edges]
	);

	return {
		items,
		hasNextPage: hasNext,
		isLoadingNext,
		loadNext: (count = DASHBOARD_TICKET_PAGE_SIZE) => loadNext(count),
	};
}
